<template>
  <div class="text-center">
    <div v-if="showDownload">
      <Button
        :label="file.name"
        class="p-button-sm"
        type="button"
        icon="pi pi-download"
        @click="downloadFile(file.url, file.name)"
      />
    </div>
    <img
      v-if="$root.fileIsImage(file)"
      :src="blobUrl"
      class="width-pdf"
      alt="Ficheiro"
    />
    <div v-else-if="$root.fileIsMkvVideo(file)" class="text-center">
      <video
        class="post-videos show-file-video"
        controls
        :src="blobUrl"
        :autoplay="autoplay"
      ></video>
    </div>
    <video
      v-else-if="$root.fileIsVideo(file)"
      class="show-file-video"
      controls
      :autoplay="autoplay"
    >
      <source :src="blobUrl" :type="$root.getFileTypeVideoSource(file)" />
      <p>{{ $t("browser_does_not_support_html5_video") }}</p>
    </video>
    <iframe
      v-else-if="$root.fileIsPdf(file)"
      :src="blobUrl"
      :title="file.name"
      :name="file.name"
      class="show-file-pdf"
      :class="{
        'is-full': fullScreen,
        'is-max-width': pdfMaxWidth,
      }"
      frameborder="0"
    ></iframe>
    <Button
      v-else
      :label="file.name"
      type="button"
      icon="pi pi-file"
      class="p-button-sm"
      @click="downloadFile(file.url, file.name)"
    />
  </div>
</template>

<script>
export default {
  props: {
    file: { type: Object, default: null },
    showDownload: Boolean,
    fullScreen: Boolean,
    pdfMaxWidth: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: false },
  },
  data() {
    return {
      blobUrl: "",
    };
  },
  computed: {
    pdfHeight() {
      return this.fullScreen ? "80vh" : "60vh";
    },
  },
  watch: {
    file() {
      if (
        this.$root.fileIsImage(this.file) ||
        this.$root.fileIsVideo(this.file) ||
        this.$root.fileIsMkvVideo(this.file) ||
        this.$root.fileIsPdf(this.file)
      ) {
        this.loadFile();
      }
    },
  },
  mounted() {
    if (this.file.url && this.file.url.startsWith("https://quadrante.")) {
      this.blobUrl = this.file.url;
    } else if (
      this.$root.fileIsImage(this.file) ||
      this.$root.fileIsVideo(this.file) ||
      this.$root.fileIsMkvVideo(this.file) ||
      this.$root.fileIsPdf(this.file)
    ) {
      this.loadFile();
    }
  },
  methods: {
    loadFile() {
      const publicPathRegex = /^(\/)?imagens\//;
      const url = this.file.url;
      if (!url) {
        return;
      }
      if (publicPathRegex.test(url)) {
        this.blobUrl = this.$root.getUrlFromFilePath(url);
      } else {
        this.blobUrl = null;
        const filename = this.file.name || url.split("/").pop();
        const apiData = this.$root.getDataToDownloadFileApi(url, filename);
        this.$root.apiGetFile(apiData.url, apiData.params).then((response) => {
          if (response) {
            this.blobUrl = URL.createObjectURL(response.data);
          }
        });
      }
    },
    downloadFile(url, filename) {
      this.isLoading = true;
      const apiData = this.$root.getDataToDownloadFileApi(url, filename);
      this.$root
        .apiGetFile(apiData.url, apiData.params)
        .then((response) => {
          this.isLoading = false;
          this.$root.downloadFile(
            response.data,
            response.headers,
            filename,
            url
          );
        })
        .catch(() => {
          this.isLoading = false;
          this.$root.toastError("file_not_found_or_stored");
        });
    },
  },
};
</script>

<style scoped>
.show-file-video {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 70vh;
  margin: 0 auto;
  object-fit: contain;
  background: #000;
}
.show-file-pdf {
  display: block;
  width: 80vw;
  max-width: 100%;
  height: 70vh;
  border: 0;
}
.show-file-pdf.is-full,
.show-file-pdf.is-max-width {
  width: 100%;
}
.show-file-pdf.is-full {
  height: 85vh;
}

@media (max-width: 1024px) {
  .show-file-pdf {
    width: 100%;
    height: 65vh;
  }
}

@media (max-width: 760px) {
  .show-file-pdf {
    height: 55vh;
  }
  .show-file-pdf.is-full {
    height: 80vh;
  }
}

@media (max-width: 480px) {
  .show-file-pdf {
    height: 50vh;
  }
}
</style>
